<div *ngIf="canEdit || !experienceSection.empty" class="bulb-experience-section">
  <div class="drag-line" pDroppable="section" (onDrop)="drop($event, experienceSection)"></div>
  <span [ngClass]="{'show-handle': !editMode && canEdit}" pDraggable="section" (onDragStart)="dragStart($event, experienceSection)" class="resume-drag-handle">
    <svg-icon
      [key]="'grip-lines-solid'"
      fontSize="1.5rem"
  >
  </svg-icon>
  </span>
  <bulb-resume-section *transloco="let t; read: 'resume.experience'"
	                     sectionName="{{ t('section') }}"
  	                   [showAddEntryButton]="showAddEntryButton"
	                     [(open)]="isTabOpen"
	                     [resumeSection]="experienceSection"
                       [resumeComponent]="resumeComponent"
	                     (onEdit)="beginEdit()"
                       [showEditIcon]="!editMode && canEdit"
                       [showDeleteIcon]="canEdit && !editMode"
                       [canEdit]="canEdit"
	                     (onNewEntry)="addEntry()"
                       (onClose)="handleTabClose()"
                       (onOpen)="handleTabOpen()"
                       pDraggable="section"
                       pDroppable="section"
                       (onDrop)="drop($event, experienceSection)"
                       (onDragStart)="dragStart($event, experienceSection)"
                       [pDraggableDisabled]="isTabOpen">
    <div sectionContent>
      <bulb-resume-sub-section *ngFor="let subsection of experienceSubSectionClone; let subSectionIndex = index"
        [units]="subsection.portfolioContent" [editMode]="subsection.editMode"
        [resumeComponent]="resumeComponent" [allowSubSectionDelete]="false" [resumeSection]="experienceSection">
        <aero-form subSectionEdit
                   submitButtonLabel="{{ 'saveButton' | transloco }}"
                   [showCancelButton]="true"
                   (onSubmit)="save($event, subSectionIndex)"
                   (onCancel)="cancelEdit(subSectionIndex)"
                   [updateSaveButtonStateOnChange]="false">
          <bulb-resume-sub-section-logo
            *ngIf="subsection.editMode"
            [logoUrl]="subsection.logoUrl || subsection.logo?.url"
            [altText]="subsection.title"
            (uploadComplete)="uploadComplete($event)"
            (delete)="deleteLogo(subSectionIndex)">
          </bulb-resume-sub-section-logo>
          <div class="row">
            <div class="columns medium-12">
              <aero-input label="{{ t('job.tile') }}" [required]="true" [(ngModel)]="subsection.title"
                [id]="'bulbResumeExperienceJobTitle-' + subSectionIndex" [maxlength]="85"
                (aeroInputNgModelEmitter)="handleInputModelChanges($event, subSectionIndex)"
                [name]="'title'">
              </aero-input>
            </div>
            <div class="columns medium-6">
              <aero-input label="{{ t('company') }}" [(ngModel)]="subsection.company"
                [id]="'bulbResumeExperienceCompany-' + subSectionIndex" [maxlength]="85"
                (aeroInputNgModelEmitter)="handleInputModelChanges($event, subSectionIndex)"
                [name]="'company'">
              </aero-input>
            </div>
            <div class="columns medium-6">
              <aero-input label="{{ t('job.location') }}" [(ngModel)]="subsection.location"
                [id]="'bulbResumeExperienceJobLocation-' + subSectionIndex" [maxlength]="85"
                (aeroInputNgModelEmitter)="handleInputModelChanges($event, subSectionIndex)"
                [name]="'location'">
              </aero-input>
            </div>
            <div class="columns medium-12">
              <div class="p-field-checkbox">
                <p-checkbox [(ngModel)]="subsection.current"
                  (ngModelChange)="resetEndDate($event, subSectionIndex)" name="current"
                  [inputId]="'bulbResumeExperienceCurrentlyWorking-' + subSectionIndex" [binary]="true">
                </p-checkbox>
                <label [for]="'bulbResumeExperienceCurrentlyWorking-' + subSectionIndex">
                  {{ t('currentlyWorking') }}
                </label>
              </div>
            </div>
            <div class="columns medium-6">
              <aero-calendar-picker label="{{ 'resume.startDate' | transloco }}"
                [(ngModel)]="subsection.startDate" [name]="'startDate'"
                [inputId]="'bulbResumeExperienceStartDate' + subSectionIndex" [dateFormat]="'mm/yy'"
                [hintMessage]="'MM/YYYY'" [pickerView]="'month'"
                errorMessage="{{ 'resume.invalidDate' | transloco }}"
                [minDate]="datepickerConfig.minDate" [maxDate]="datepickerConfig.maxDate"
                [yearRange]="datepickerConfig.range" (ngModelChange)="handleInputModelChanges($event, subSectionIndex)">
              </aero-calendar-picker>
            </div>
            <div class="columns medium-6">
              <aero-calendar-picker label="{{ 'resume.endDate' | transloco }}"
                [(ngModel)]="subsection.endDate" [name]="'endDate'"
                [inputId]="'bulbResumeExperienceEndDate' + subSectionIndex" [dateFormat]="'mm/yy'"
                [disabled]="subsection.current" hintMessage="MM/YYYY" pickerView="month"
                errorMessage="{{ 'resume.invalidDate' | transloco }}"
                [placeholder]="subsection.endDatePlaceholder" [minDate]="datepickerConfig.minDate"
                (ngModelChange)="handleInputModelChanges($event, subSectionIndex)"
                [maxDate]="datepickerConfig.maxDate" [yearRange]="datepickerConfig.range">
              </aero-calendar-picker>
            </div>
            <div class="bulb-work-experience-content columns medium-12">
              <div class="bulb-label-container">
                <label transloco="resume.experience.description.summary">
                  Work Experience Summary
                </label>
                <bulb-editor *ngIf="subsection.editMode"
                             name="experienceSummary"
                             id="experienceSummary"
                             [editable]="true"
                             [initData]="subsection.summary"
                             (limitReached)="handleLimitReached($event)"
                             (dataChange)="updateSummaryData($event, subSectionIndex)"
                             [maxLength]="maxLength">
                </bulb-editor>

                <label transloco="resume.experience.description.highlights">
                  Work Experience Highlights
                </label>
                <span aeroTooltipPosition="top" tabindex="0"
                      attr.aria-label="{{ 'resume.experience.description.tooltip' | transloco }}"
                      aeroTooltip="{{ 'resume.experience.description.tooltip' | transloco }}"
                      role="tooltip">
                  <i class="fal fa-info-circle"></i>
                </span>
              </div>
              <div class="bulb-experience-description">
                <div class="bulb-experience-description-list-items">
                  <i class="fa fa-circle"></i>
                  <aero-textarea placeholder="{{ 'resume.experience.achievements' | transloco }}"
                    [autoResize]="true" [rows]="1"
                    (contentChangeHandler)="handleInputModelChanges($event, subSectionIndex)"
                    [id]="'workExperienceDescFirst-' + subSectionIndex"
                    ariaLabel="{{ 'resume.experience.firstDescription' | transloco }}"
                    [(ngModel)]="subsection.achievements" name="achievements" [maxlength]="textAreaMaxLength">
                  </aero-textarea>
                </div>
                <div class="bulb-experience-description-list-items">
                  <i class="fa fa-circle"></i>
                  <aero-textarea placeholder="{{ 'resume.experience.responsibilities' | transloco }}"
                    [autoResize]="true" [rows]="1"
                    (contentChangeHandler)="handleInputModelChanges($event, subSectionIndex)"
                    [id]="'workExperienceDescSecond-' + subSectionIndex"
                    [(ngModel)]="subsection.responsibilities" name="responsibilities"
                    ariaLabel="{{ 'resume.experience.secondDescription' | transloco }}"
                    [maxlength]="textAreaMaxLength">
                  </aero-textarea>
                </div>
                <div class="bulb-experience-description-list-items">
                  <i class="fa fa-circle"></i>
                  <aero-textarea placeholder="{{ 'resume.experience.strengths' | transloco }}"
                    [autoResize]="true" [rows]="1"
                    (contentChangeHandler)="handleInputModelChanges($event, subSectionIndex)"
                    [id]="'workExperienceDescThird-' + subSectionIndex"
                    [(ngModel)]="subsection.strengths" name="strengths"
                    ariaLabel="{{ 'resume.experience.thirdDescription' | transloco }}"
                    [maxlength]="textAreaMaxLength">
                  </aero-textarea>
                </div>
                <div class="bulb-experience-description-list-items"
                     *ngFor="let workHighlight of subsection.workHighlights; trackBy: trackByWorkHighlights;let highlightIndex = index">
                  <i class="fa fa-circle"></i>
                  <aero-textarea placeholder="{{ 'resume.experience.moreWorkDescription' | transloco }}"
                                 [autoResize]="true" [rows]="1"
                                 (contentChangeHandler)="handleInputModelChanges($event, subSectionIndex)"
                                 [id]="'workExperienceDescHighlights-' + subSectionIndex + '-' + highlightIndex"
                                 [(ngModel)]="subsection.workHighlights[highlightIndex]"
                                 [name]="'workExperienceDescHighlights-' + subSectionIndex + '-' + highlightIndex"
                                 ariaLabel="{{ 'resume.experience.thirdDescription' | transloco }}"
                                 [maxlength]="textAreaMaxLength">
                  </aero-textarea>
                </div>
                <div class="text-left bulb-resume-add-btn">
                  <aero-button [aeroStyle]="addPortfolioContentButtonStyle" icon="fal fa-plus"
                               label="{{ 'resume.add.workHighlight' | transloco }}"
                               (onClick)="addWorkHighlight(subSectionIndex)">
                  </aero-button>
                </div>
              </div>
            </div>
            <div class="text-center bulb-resume-add-btn">
              <aero-button [aeroStyle]="addPortfolioContentButtonStyle" icon="fal fa-plus"
                label="{{ 'resume.add.portfolioContent' | transloco }}"
                (onClick)="addPortfolioContent(subSectionIndex)">
              </aero-button>
            </div>
            <!-- Show the selected portfolio content : -->
            <bulb-resume-content-selection-display
              [aeroFormComponent]="aeroFormComponentList.toArray()[subSectionIndex]"
              [resumeSubSection]="this" [editMode]="subsection.editMode"
              [units]="subsection.portfolioContent" [renderResumeSubSectionTileView]="true"
              (onUnitRemoved)="onPortfolioContentRemoved($event, subSectionIndex)">
            </bulb-resume-content-selection-display>
          </div>
        </aero-form>
        <div subSectionView>
          <div class="bulb-experience-view">
            <div class="row">
              <div [ngClass]="{'columns small-1': isLogoUploaded}">
                <div *ngIf="subsection.logo?.url" class="bulb-resume-section-logo-image-view">
                  <img [src]="subsection.logo?.url" [alt]="subsection.title">
                </div>
              </div>
              <div class="columns small-11 padding-left">
                <div class="bulb-experience-title">
                  {{subsection.title}}
                </div>
                <div class="bulb-experience-section">
              <span *ngIf="subsection.company">
                {{subsection.company}}
              </span>
                  <span *ngIf="subsection.company && subsection.location"> |</span>
                  <span *ngIf="subsection.location">
                {{subsection.location}}
              </span>
                  <span *ngIf="subsection.location && (subsection.startDate || subsection.endDate)"> |</span>
                  <span *ngIf="subsection.startDate || subsection.endDate">
                {{subsection.startDate | date:'MMM yyyy'}} -
                <span *ngIf="subsection.current; else endDate">{{this.endDatePlaceholder}}</span>
                <ng-template #endDate>
                  {{subsection.endDate | date:'MMM yyyy'}}
                </ng-template>
              </span>
                </div>
                <div [innerHTML]="subsection.summary" class="bulb-resume-experience-summary"></div>
                <div class="bulb-experience-description"
                     *ngIf="subsection.achievements || subsection.responsibilities || subsection.strengths || subsection.workHighlights">
                  <ul>
                    <li *ngIf="subsection.achievements">
                      {{subsection.achievements}}
                    </li>
                    <li *ngIf="subsection.responsibilities">
                      {{subsection.responsibilities}}
                    </li>
                    <li *ngIf="subsection.strengths">
                      {{subsection.strengths}}
                    </li>
                  </ul>
                  <ul *ngFor="let workHighlight of subsection.workHighlights">
                    <li>{{workHighlight}}</li>
                  </ul>
                </div>
                <div *ngIf="canEdit" class="bulb-view-section-buttons">
                  <div class="edit-entry-button">
                    <aero-button [aeroStyle]="buttonStyle" icon="far fa-pencil" [size]="buttonSize"
                                 labelCode="button_edit" (onClick)="beginEdit(subSectionIndex)">
                    </aero-button>
                  </div>
                  <div class="delete-entry-button">
                    <aero-button [aeroStyle]="buttonStyle" icon="fal fa-trash-alt" [size]="buttonSize"
                                 (onClick)="deleteEntry($event, subSectionIndex)" labelCode="button_delete">
                    </aero-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </bulb-resume-sub-section>
    </div>
  </bulb-resume-section>
</div>
